export default "__VITE_ASSET__BEfy_QEv__"